import React from 'react';
import { Field } from '@h2/types';

interface ToggleInputProps {
  field: Field;
  value: boolean;
  onChange: (value: boolean) => void;
  error?: string;
}

export const ToggleInput: React.FC<ToggleInputProps> = ({ field, value, onChange, error }) => {
  return (
    <div className="flex items-center justify-between">
      <span className="text-sm text-gray-700">
        {field.placeholder || '활성화'}
      </span>
      <button
        type="button"
        onClick={() => onChange(!value)}
        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${
          value ? 'bg-blue-600' : 'bg-gray-200'
        }`}
      >
        <span
          className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
            value ? 'translate-x-6' : 'translate-x-1'
          }`}
        />
      </button>
    </div>
  );
};
